<template>
  <v-app>
    <v-main>
      <GlobalLoader :loading="isLoading" />
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import GlobalLoader from "@/components/Complement/GlobalLoader.vue";
export default {
  components: {
    GlobalLoader,
  },
  name: "App",
  data: () => ({
    token: "",
  }),
  async created() {
    if (sessionStorage.getItem("reloaded") == null) {
      localStorage.removeItem("token");
      this.$router.push("/Dashboard");
    }
  },
  mounted() {
    this.token = localStorage.getItem("token");

    if (this.token == null) {
      this.$router.push("/signIn");
    }
    if (
      localStorage.getItem("dialogTwoFA") &&
      localStorage.getItem("active2fa") === "true"
    ) {
      this.$router.push("/Autenticacion");
    }
  },
  methods: {
    logout() {
      window.onunload;
    },
  },
  computed: {
    isLoading() {
      return this.$store.getters["loader/isLoading"];
    },
  },
};
</script>
<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Ubuntu:wght@300&display=swap");
@import "~ag-grid-community/styles/ag-grid.css";
@import "~ag-grid-community/styles/ag-theme-quartz.css";

* {
  font-family: "Ubuntu", sans-serif;
  scrollbar-width: none;
  scrollbar-color: #82a1d0 #ffffff;
}

main {
  background-color: #dce2ef;
  position: absolute;
  width: 100% !important;
  height: 100%;
  background-size: cover;
  overflow-y: scroll;
  overflow-x: hidden;
}
*::-webkit-scrollbar {
  width: 10px;
}

*::-webkit-scrollbar-track {
  background: #ffffff;
}

*::-webkit-scrollbar-thumb {
  background-color: #82a1d0;
  border-radius: 10px;
  border: 3px solid #ffffff;
}
.v-menu__content
  .theme--light
  .v-menu__.content--fixed
  .menuable__content__active {
  max-width: 490px !important;
  min-width: inherit;
}
label {
  font-size: 14px !important;
}
</style>
